import React, { FC } from 'react';
import { Typography } from '@mui/material';
import OverviewComponent from '../OverviewComponent/OverviewComponent';
import IndicatorsComponent from '../IndicatorsComponent/IndicatorsComponent';
import { BodyComposition } from '../../../services/DataFormatService';

interface BodyCompositionComponentProps {
    bodyComposition: BodyComposition;
}

const BodyCompositionComponent: FC<BodyCompositionComponentProps> = (props) => {
    const { bodyComposition } = props;
    return (
        <div data-testid="BodyCompositionComponent">
            <Typography
                variant="h1"
                sx={{ pb: 4 }}
            >
                Body Composition
            </Typography>
            <OverviewComponent bodyComposition={bodyComposition} />
            <br />
            <IndicatorsComponent bodyComposition={bodyComposition} />
        </div>
    );
};

export default BodyCompositionComponent;
